/**
 * 忘记密码功能工具函数
 *
 * 提供手机号验证和密码验证功能，用于国内模式下的手机号密码重置流程
 */

/**
 * 中国大陆手机号正则表达式
 * 格式：1开头，第二位为3-9，后面跟9位数字
 * 例如：13812345678, 15912345678, 18812345678
 */
const CHINA_PHONE_REGEX = /^1[3-9]\d{9}$/;

/**
 * 密码最小长度
 */
export const MIN_PASSWORD_LENGTH = 6;

/**
 * 验证中国大陆手机号格式
 *
 * 规则：
 * - 必须是11位数字
 * - 以1开头
 * - 第二位为3-9
 *
 * @param phone - 手机号字符串
 * @returns 是否为有效的中国大陆手机号
 *
 * @example
 * isValidPhoneNumber('13812345678') // true
 * isValidPhoneNumber('12345678901') // false (第二位不是3-9)
 * isValidPhoneNumber('1381234567')  // false (不足11位)
 */
export function isValidPhoneNumber(phone: string): boolean {
  if (typeof phone !== "string") {
    return false;
  }
  return CHINA_PHONE_REGEX.test(phone);
}

/**
 * 验证密码是否满足最小长度要求
 *
 * 规则：
 * - 密码长度必须大于等于6个字符
 *
 * @param password - 密码字符串
 * @returns 是否满足最小长度要求
 *
 * @example
 * isValidPassword('123456')  // true
 * isValidPassword('12345')   // false (不足6位)
 * isValidPassword('')        // false (空字符串)
 */
export function isValidPassword(password: string): boolean {
  if (typeof password !== "string") {
    return false;
  }
  return password.length >= MIN_PASSWORD_LENGTH;
}
